/**
 * 计算任务赏金对应的零豆
 * @param salary
 * @returns {string}
 */
export let calculatePoints = (salary) => {
  salary = salary <= 0 ? 0 : (salary * 1)
  if (salary === 0) {
    return '0'
  } else if (salary > 0 && salary < 5) {
    return '5'
  } else if (salary >= 5 && salary < 10) {
    return '10'
  } else if (salary >= 10 && salary < 20) {
    return '15'
  } else if (salary >= 20 && salary < 30) {
    return '20'
  } else if (salary >= 30 && salary < 50) {
    return '30'
  } else if (salary >= 50) {
    return '40'
  }
}



// WEBPACK FOOTER //
// ./src/views/task/components/task-functions.js